<template>
    <section class="grid-articles">
        <ul class="grid-articles--list u-reset">
            <slot/>
            <li class="grid-articles--tile" v-for="(article) in articles" :key="article.path">
                <a class="grid-articles--tile-link u-reset" :href="article.path">
                    <figure class="grid-articles--tile-figure" v-if="article.image && article.image.urls">
                        <img :src="getImageSrc(article)" :alt="getImageAlt(article)" class="grid-articles--tile-image">
                    </figure>
                    <div :class="article.image && article.image.urls ? 'grid-articles--tile-container' : 'grid-articles--tile-container-without-image'">
                        <div>
                            <h3 class="grid-articles--tile-title grid-articles--dark-text" itemprop="headline">
                                {{ article.title }}
                            </h3>
                            <h4 class="grid-articles--tile-subtitle" itemprop="description">
                                {{ article.lead_list }}
                            </h4>
                            <div :class="article.image && article.image.urls ? 'grid-articles--tile-article-info-container' : 'grid-articles--tile-article-info-container-with-margin'">
                                <p class="grid-articles--tile-article-info" itemprop="author">
                                    {{ article.author }}
                                </p>
                                <p class="grid-articles--tile-article-info" itemprop="datePublished">
                                    {{ article.publication_date }}
                                </p>
                            </div>
                        </div>
                        <div>
                            <div class="grid-articles--tile-footer">
                                <p class="grid-articles--tile-tag" itemprop="keywords" v-if="article.category">
                                    {{ article.category }}
                                </p>
                                <div class="grid-articles--tile-arrow-wrapper grid-articles--dark-text">
                                    <div class="grid-articles--tile-arrow"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </li>
        </ul>
        <button class="grid-articles--button-load" v-if="paginator.has_next" @click="onclick">
            {{ paginator.load_more_label }}
        </button>
    </section>
</template>

<script>
    import Axios from '../../../util/service';

    export default {
        props: {
            articles: {
                type: Array,
                requied: true,
                default: () => [],
            },
            paginator: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },
        methods: {
            getImageSrc(article) {
                if (article.image && article.image.urls && article.image.urls.default) {
                    return article.image.urls.default[0];
                }
                return '';
            },
            getImageAlt(article) {
                if (article.image && article.image.alt) {
                    return article.image.alt;
                }
                return '';
            },
            onclick() {
                Axios.get(this.paginator.load_more, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: null, // See: https://github.com/axios/axios/issues/86#issuecomment-389298860
                }).then((res) => {
                    this.articles.push(...res.data.articles);
                    this.paginator = res.data.paginator;
                });
            },
        },
    };
</script>
